export const SHARE_TITLE = "activation.home.list.item.share.title";
